import React, { useState, useEffect } from 'react';
import ProgramService from './ProgramService';
import Alert from 'react-bootstrap/Alert';
import filterFieldsForList from '../../common/functions/filterFieldsForList';
import filterDataForList from '../../common/functions/filterDataForList';
import schema from './jsonSchema';
import AdvanceList from '../../common/AdvanceList';
import { useNavigate } from 'react-router-dom';
import useHeaderGenerator from '../../common/functions/useHeaderGenerator';
import { Link } from 'react-router-dom';
const formatDate = dateValue => {
  let date;

  // Handle date as array [year, month, day]
  if (Array.isArray(dateValue)) {
    const [year, month, day] = dateValue;
    date = new Date(year, month - 1, day);
  } else {
    date = new Date(dateValue);
  }

  // Format as DD/MM/YYYY
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};
const ProgramList = () => {
  const [data, setData] = useState();
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);

  const navigate = useNavigate();
  const transformData = (attr, item) => {
    if (attr === 'name') {
      const url = '/app/wod/programs/' + item['identifier'];
      return <Link to={url}>{item[attr]}</Link>;
    }
    if (attr === 'date'){
      return formatDate(item[attr]);
    }
    return item[attr];
  };
  useEffect(() => {
    const jsonSchema = schema;
    const fieldsForList = filterFieldsForList(jsonSchema);
    setColumns(fieldsForList);

    ProgramService.retrieveAllProgramByAccount()
      .then(data => {
      const sortedPrograms = [...data].sort((a, b) =>
        b.date.localeCompare(a.date)
      );
        setData(
          filterDataForList(
            sortedPrograms,
            columns.map(c => c.accessor),
            transformData
          )
        );
        setNoDataToShow(!sortedPrograms.length > 0);
      })
      .catch(error => setError({ error: error.message }));
  }, [noDataToShow]);
  const buttonsConf = [
    {
      name: 'Create a new Program',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Create a new Program');
        navigate('/app/annoucements/create-form');
      }
    },
    {
      name: 'Save Draft',
      type: 'submit',
      variant: 'success',
      onClick: () => {
        console.log('Save Draft');
      }
    }
  ];
  const headerGenerated = useHeaderGenerator(
    'Create Program',
    ' ',
    buttonsConf
  );
  return (
    <>
      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any Program to show. Let's create a new one!
        </Alert>
      )}
      {data && <AdvanceList searchBox={true} columns={columns} data={data} />}
    </>
  );
};

export default ProgramList;
